import { useQueryClient } from '@mint-lib/query-client';
import { Chat } from '@mint-sdk/api-ai-assistant';

export const useChatHistoryState = () => {
  const queryClient = useQueryClient();

  const addNewMsgToLocalState = (
    chatId: string,
    message: Chat.ChatMessageRecordType,
  ) => {
    queryClient.setQueryData(
      Chat.getHistoryById.queryKey.dataTag({
        urlParams: { chatSessionId: chatId },
      }),
      (
        chatHistory: Chat.ChatMessageRecordType[] | undefined,
      ): Chat.ChatMessageRecordType[] => {
        if (!chatHistory?.length) {
          return [message];
        }

        return [...chatHistory, message];
      },
    );
  };

  //FYI: after a successful socket send clears both draft flags so the message is no longer treated as a draft
  const updateMsgSendViaSocket = (chatId: string, lastUserMsgId: number) => {
    queryClient.setQueryData(
      Chat.getHistoryById.queryKey.dataTag({
        urlParams: { chatSessionId: chatId },
      }),
      (
        chatHistory: Chat.ChatMessageRecordType[] | undefined,
      ): Chat.ChatMessageRecordType[] => {
        return (
          chatHistory?.map((el) => {
            if (el.messageId === lastUserMsgId && el.message.type === 'human') {
              return {
                ...el,
                message: {
                  ...el.message,
                  isMsgStub: false,
                  isApprovingStub: false,
                },
              };
            }

            return el;
          }) || []
        );
      },
    );
  };

  return {
    addNewMsgToLocalState,
    updateMsgSendViaSocket,
  };
};
